import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ParamInjectorServices {
  constructor(private route: ActivatedRoute) {}

  injectParams(target: any) {
    const params = this.route.snapshot.queryParams;

    Object.keys(params).forEach(key => {
      if (target.hasOwnProperty(key)) {

        let raw = params[key];
        let current = target[key];

        // Se o target já tem um valor, usamos ele para inferir o tipo
        if (typeof current === 'number') {
          target[key] = Number(raw);
        }
        else if (typeof current === 'boolean') {
          target[key] = raw === 'true' || raw === true;
        }
        else if (Array.isArray(current)) {
          try {
            target[key] = JSON.parse(raw);
          } catch {
            target[key] = [raw];
          }
        }
        else if (typeof current === 'object' && current !== null) {
          try {
            target[key] = JSON.parse(raw);
          } catch {
            target[key] = raw;
          }
        }
        else {
          // string ou qualquer outro tipo
          target[key] = raw;
        }
      }
    });
  }
}